export class AdapterCallbacks {
    onPlayerReady = null;
    onPositionChanged = null;
    onSeekableRangeChanged = null;
    onSeeked = null;
    onAvailableSubtitlesTracksChanged = null;
    onAvailableAudioTracksChanged = null;
    onSelectedAudioTrackChanged = null;
    onSelectedSubtitlesTrack = null;
    onCastMediaTracksChanged = null;
    onCastMediaTrackSelectionChanged = null;
    onPlay = null;
    onPlaybackStateChanged = null;
    onPlaybackDurationChanged = null;
    onVideoBitrateChanged = null;
    onError = null;
    onGeometryChanged = null;
    onBandwidthMeasured = null;
    onPlaybackEnded = null;
    onLatencyChanged = null;
    onDroppedFrames = null;
    onAdBreakStarted = null;
    onAdBreakEnded = null;
    onAdLoaded = null;
    onAdStarted = null;
    onAdPaused = null;
    onAdPositionChanged = null;
    onAdEnded = null;
    onAdSkipped = null;
    onAdResumed = null;
    onAdMetadata = null;
    onAdFirstQuartile = null;
    onAdMidpoint = null;
    onAdThirdQuartile = null;
    onAdError = null;
    onContentPauseRequested = null;
    onContentResumeRequested = null;
    onPauseAdParsed = null;
    onAdSkipAvailable = null;
    onAdSkipUnavailable = null;
}
